import { request } from '../../../service/common';
import { layers } from './apiUrl';

export const getLayers = async ({ layerType }) => {
  const { data } = await request.get(layers.list, {
    params: {
      layerType,
    },
  });
  return data.datas;
};

export const addLayers = async ({ srid, layerType, file, isOverwrite }) => {
  const formData = new FormData();
  formData.append('zipFile', file);
  const { data } = await request.post(layers.add, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    params: {
      srid,
      layerType,
      isOverwrite,
    },
  });
  return data.datas;
};

export const getLayerDetail = async ({ layerId }) => {
  const { data } = await request.get(layers.detail(layerId));
  return data.datas;
};

export const getEastLayers = async (leyerId, bbox) => {
  const { data } = await request.get(layers.east(leyerId), {
    params: {
      minX: bbox.minX,
      minY: bbox.minY,
      maxX: bbox.maxX,
      maxY: bbox.maxY,
    },
  });
  return data.datas;
};

export const getCenterLayers = async (layerId, bbox) => {
  const { data } = await request.get(layers.center(layerId), {
    params: {
      minX: bbox.minX,
      minY: bbox.minY,
      maxX: bbox.maxX,
      maxY: bbox.maxY,
    },
  });
  return data.datas;
};
export const deleteLayer = async (layerId) => {
  const { data } = await request.delete(layers.delete(layerId));
  return data.datas;
};

export const patchPublishLayer = async (layerId) => {
  const { data } = await request.patch(layers.publish(layerId), {});
  return data.datas;
};
